module.exports = __webpack_public_path__ + "img/galvanic.db642f27.png";